import { jsx as _jsx } from "react/jsx-runtime";
// Importing custom components
import { IconButton } from '../core/icon-button';
// Importing hooks
import { useDate } from '../../hooks/use-date';
import { useShallow } from 'zustand/react/shallow';
// Importing icons
import PlayIcon from '@mui/icons-material/PlayCircleOutlineRounded';
// Importing store
import { usePostStore } from '../../store/post.store';
import Stack from '@mui/material/Stack';
// ----------------------------------------------------------------------
export const PauseScreen = (props) => {
    // Adding hooks
    const { formatDate } = useDate();
    // Adding post store
    const { post } = usePostStore(useShallow((state) => ({
        post: state.post,
    })));
    return (_jsx(Stack, { alignItems: "center", height: '100%', justifyContent: "center", display: { xs: 'none', sm: 'flex' }, children: _jsx(IconButton, { "aria-label": "play", sx: {
                animation: 'playIconFadeUp 0.125s forwards',
                '@keyframes playIconFadeUp': {
                    '0%': { opacity: 0, scale: 3, transform: 'translate(0%,100%)' },
                    '100%': { opacity: 1, scale: 1, transform: 'translate(0%,0%)' },
                },
            }, children: _jsx(PlayIcon, { fontSize: "xlarge", sx: { backgroundColor: 'primary.main', borderRadius: '50%', p: 1 } }) }) }));
    // return (
    //   <Fragment>
    //     <Stack
    //       alignItems="center"
    //       height={'100%'}
    //       justifyContent="center"
    //       display={{ xs: 'none', sm: 'flex' }}
    //     >
    //       <IconButton
    //         aria-label="play"
    //         sx={{
    //           animation: 'playIconFadeUp 0.125s forwards',
    //           '@keyframes playIconFadeUp': {
    //             '0%': { opacity: 0, scale: 3, transform: 'translate(0%,100%)' },
    //             '100%': { opacity: 1, scale: 1, transform: 'translate(0%,0%)' },
    //           },
    //         }}
    //       >
    //         <PlayIcon fontSize="xxlarge" />
    //       </IconButton>
    //     </Stack>
    //     <Grid
    //       item
    //       top={0}
    //       position="absolute"
    //       width="100%"
    //     >
    //       <Grid
    //         container
    //         paddingInline={4}
    //         pt={4}
    //       >
    //         <Grid
    //           item
    //           display={{ xs: 'none', md: 'flex' }}
    //           xs={6}
    //         >
    //           {post && (
    //             <Grid
    //               container
    //               spacing={2}
    //               alignItems={'center'}
    //             >
    //               <Grid
    //                 item
    //                 xs={3}
    //               >
    //                 <Box
    //                   component={'img'}
    //                   src={post.thumbnail}
    //                   sx={{
    //                     border: 2,
    //                     borderStyle: 'solid',
    //                     borderRadius: 2,
    //                     borderColor: 'white',
    //                     maxWidth: '150px',
    //                     width: '100%',
    //                   }}
    //                 />
    //               </Grid>
    //               <Grid
    //                 item
    //                 xs={9}
    //               >
    //                 <Typography
    //                   color="white"
    //                   maxWidth={'80%'}
    //                   noWrap
    //                   variant="h6"
    //                 >
    //                   {post.title}
    //                 </Typography>
    //                 <Typography
    //                   color="white"
    //                   maxWidth={'90%'}
    //                   noWrap
    //                   variant="body2"
    //                 >
    //                   {post.teaser}
    //                 </Typography>
    //                 <Typography
    //                   color="white"
    //                   maxWidth={'90%'}
    //                   noWrap
    //                   variant="body2"
    //                 >
    //                   {formatDate(post.date)}
    //                 </Typography>
    //               </Grid>
    //             </Grid>
    //           )}
    //         </Grid>
    //         <Grid
    //           item
    //           display="flex"
    //           alignItems="start"
    //           justifyContent="end"
    //           xs={6}
    //         >
    //           <Stack direction="row">
    //             <IconButton aria-label="backwards">
    //               <ShareIcon />
    //             </IconButton>
    //           </Stack>
    //         </Grid>
    //       </Grid>
    //     </Grid>
    //   </Fragment>
    // );
};
